<script>
  import { Router, Link, Route } from "svelte-routing";
  import { QueryClient, QueryClientProvider } from "@sveltestack/svelte-query";

  import Page from "./Page.svelte";
  import Reports from "./Reports.svelte";
  import Plans from "./Plans.svelte";
  import Profile from "./profile/Profile.svelte";
  import TestBanner from "./TestBanner.svelte";
  import MissingPrivacyConsent from "./profile/MissingPrivacyConsent.svelte";
  import setupI18n from "./i18n.js";
  import { _ } from "svelte-i18n";

  setupI18n();
  const version = __APP_VERSION__;

  export let url = "";
  let currentPage =
    window.location.pathname === "/planer"
      ? "Planer"
      : window.location.pathname === "/profil"
        ? "Profile"
        : window.location.pathname === "/statistikk/individuell/rapporter"
          ? "Statistikk"
          : window.location.pathname === "/varsler"
            ? "Varsler"
            : "Oversikt";

  function viewOversikt() {
    currentPage = "Oversikt";
  }

  function viewStatistikk() {
    currentPage = "Statistikk";
  }

  function viewPlans() {
    currentPage = "Planer";
  }

  function viewProfile() {
    currentPage = "Profile";
  }

  function viewNotifications() {
    currentPage = "Varsler";
  }

  const queryClient = new QueryClient();
  const user = localStorage.getItem("user");
</script>

<QueryClientProvider client={queryClient}>
  <Router {url}>
    <div class="page">
      <TestBanner />
      <header class="status-bar">
        <Link
          aria-current={currentPage === "Oversikt" ? "true" : "false"}
          to="/"
          on:click={viewOversikt}
          class="status-bar__button status-bar__button--main status-bar__button--training {currentPage ===
          'Oversikt'
            ? 'is-current'
            : ''}"
        >
          <span class="status-bar__button-text"
            >{$_("navigation.overview")}</span
          >
        </Link>
        <Link
          aria-current={currentPage === "Planer" ? "true" : "false"}
          to="/planer"
          on:click={viewPlans}
          class="status-bar__button status-bar__button--main status-bar__button--planning {currentPage ===
          'Planer'
            ? 'is-current'
            : ''}"
        >
          <span class="status-bar__button-text"
            >{$_("navigation.training")}</span
          >
        </Link>
        <Link
          aria-current={currentPage === "Statistikk" ? "true" : "false"}
          to="/statistikk/individuell/rapporter"
          on:click={viewStatistikk}
          class="status-bar__button status-bar__button--main status-bar__button--statistics {currentPage ===
          'Statistikk'
            ? 'is-current'
            : ''}"
        >
          <span class="status-bar__button-text"
            >{$_("navigation.statistics")}</span
          >
        </Link>
        <span class="status-bar__button-spacer" />
        <Link
          aria-current={currentPage === "Varsler" ? "true" : "false"}
          to="/varsler"
          on:click={viewNotifications}
          class="status-bar__button status-bar__button--notifications {currentPage ===
          'Varsler'
            ? 'is-current'
            : ''}"
        >
          <span class="status-bar__button-text">0</span>
        </Link>
        <Link
          aria-current={currentPage === "Profile" ? "true" : "false"}
          to="/profil"
          on:click={viewProfile}
          class="status-bar__button status-bar__button--profile {currentPage ===
          'Profile'
            ? 'is-current'
            : ''}"
        >
          <span class="status-bar__button-text">{$_("navigation.myPage")}</span>
        </Link>
        {#if !user}
          <div
            style="width: 100%;height: 27px;border: 2px solid black;background-color: brown;color: yellow;"
          >
            <div
              style="text-align: center;color: yellow;"
              class="layout__title layout__title--inline"
            >
              {$_("navigation.notLoggedIn")}
            </div>
          </div>
        {/if}
      </header>
      <Route path="/statistikk/individuell/rapporter" component={Reports} />
      <Route path="/planer" component={Plans} />
      <Route path="/profil" component={Profile} />
      <Route path="/">
        <Page />
      </Route>
      <MissingPrivacyConsent />
      <footer class="page-footer">
        <a href="https://friendsta.tech/" class="page-footer__logo">
          <img
            src="/static/friendstaLogo.png"
            alt="Logo for Friendsta AS"
            style="width:150px"
          />
        </a>
        <p class="page-footer__support">
          {$_("footer.contact1")}
          <a href="sms:+4790508006;?&body=Hei! Jeg bruker treningsdagboken og "
            >{$_("footer.contact2")}
            <span style="white-space: no-wrap">905 08 006</span></a
          >.
        </p>
        <p>{$_("footer.version")}: {version}</p>
      </footer>
    </div></Router
  >
</QueryClientProvider>

<style>
</style>
